module.exports = __webpack_public_path__ + "img/slide2.4f8f3b6f.webp";